import { AuditSectionRoot } from './styled';
import type { AuditSectionProps } from './types';

/** Wrapper for collapsible webhook / history tables. */
const AuditSection = ({ children }: AuditSectionProps) => <AuditSectionRoot>{children}</AuditSectionRoot>;

export default AuditSection;

export { CollapsiblePanel, EmptyCell, MonoCell, PanelCount, PanelSummary, Table, TableWrap, Td, Th } from './styled';
